<p *ngIf="platformFee" class="platform-fee">Ketto’s <span><span class="font-s">0</span>% Platform fees*</span> ensures maximum funds for you</p>
<button class="start-fundraiser-btn" mat-raised-button (click)="sendEvent('English')"
  [ngStyle]="{'width': width, 'height': height, 'font-size': font, 'line-height': lineHeight}" [innerHTML]="label">
</button>
